(function () {
  function slideOffset(slider, slides) {
    const visible = Array.from(slides).filter((el) => el.clientWidth > 0);
    if (visible.length < 2) return slider.clientWidth || 1;
    return visible[1].offsetLeft - visible[0].offsetLeft;
  }

  function wirePdpResultsSlider(sectionRoot) {
    const viewer = sectionRoot.querySelector('[data-pdp-results-viewer]');
    const dotsRoot = sectionRoot.querySelector('.pdp-real-results__dots');
    if (!viewer || !dotsRoot || viewer.dataset.pdpResultsDotsWired === 'true') return;
    viewer.dataset.pdpResultsDotsWired = 'true';

    const slider = viewer.querySelector('[id^="Slider-"]');
    const slides = viewer.querySelectorAll('[id^="Slide-"]');
    const dots = dotsRoot.querySelectorAll('[data-pdp-results-dot]');

    const setActiveDot = (page) => {
      const n = typeof page === 'number' ? page : 1;
      dots.forEach((dot, i) => {
        const on = i + 1 === n;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-pdp-results-dot'), 10);
        if (!slider || !index) return;
        const off = slideOffset(slider, slides);
        slider.scrollTo({ left: (index - 1) * off, behavior: 'smooth' });
      });
    });

    viewer.addEventListener('slideChanged', (event) => {
      const page = event.detail && event.detail.currentPage;
      if (page) setActiveDot(page);
    });

    setActiveDot(1);
  }

  function init() {
    document.querySelectorAll('[data-pdp-results-slider]').forEach(wirePdpResultsSlider);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
